/**
 * Pure H OS · Phase D Wave 4 · Product Workspace (types + live view).
 * MongoDB collection: `pureh_products_hub`.
 */
import { liveArray } from "../services/store";

export type ProductLaunchStatus =
  | "discovery" | "reformulation" | "pre-launch" | "live" | "killed";

export type ProductHubRow = {
  id: string;
  sku: string;
  name: string;
  category: string;
  launchStatus: ProductLaunchStatus;
  monthlyRevenueEGP: number;
  unitsShipped: number;
  marginPct: number;
  blindPanelScore: number;
  activeCampaigns: number;
  leadPerfumer: string;
  notes: string;
};

export const PRODUCTS_HUB: ProductHubRow[] = liveArray<ProductHubRow>("products_hub");
